import * as React from "react";
import { ErrorPage } from "./ErrorPage";
export const BrowserErrorView = () => {
    return React.createElement(ErrorPage, { message: "Your browser version is not supported." });
};
